import { ChangeEvent } from 'react';
import { FormField } from '@nimbus-ds/patterns';
import { ExternalLink } from 'commons/components';
import useTranslationConfigurations from 'domains/Configurations/useTranslationConfigurations';
import { SplitSection } from '../SplitSection';

interface AfipProps {
  onChangeTextArea: (e: ChangeEvent<HTMLTextAreaElement>) => void;
  afip?: string;
}

export function Afip({ onChangeTextArea, afip }: Readonly<AfipProps>) {
  const t = useTranslationConfigurations('externalCodes.otherServices.afip');

  return (
    <SplitSection title={t('title')} description={t('description')}>
      <FormField.Textarea
        onChange={onChangeTextArea}
        value={afip}
        name="afip"
        id="afip"
        placeholder={t('placeholder')}
        label={t('label')}
        lines={6}
      />
      <ExternalLink href={t('href')} appearance="primary" textDecoration="none">
        {t('link')}
      </ExternalLink>
    </SplitSection>
  );
}
